import React from 'react'
import { StyledTableHeader } from './styles'
import { Box, Typography, useMediaQuery } from '@mui/material'
import CellBadge from './CellTypes/CellBadge'
import { useTheme } from '@mui/material/styles'
import GenericButton from '../GenericButton'
import { ButtonSize, ButtonType } from '../GenericButton/styles'
import Search from '../Search'
import { type DataObjectList } from '../../models/DataObject'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { type Row } from './types'
import TableGuidelines from './TableGuidelines'
import { grey } from '../../colors'
import { capitalizeFirst } from '../../utils/utils'

interface TableTopBarActionsProps {
  list?: DataObjectList<Row> | null
  title: string | undefined
  label?: string | undefined
  exportCsv?: () => void
  createActionTitle?: string
  customTopbarAction?: React.ReactNode
  handleCreateActionModal: () => void
  createButtonProps?: object | undefined
  onSearch?: (value: string) => void
  exportButtonProps?: object | undefined
}

const TableTopBarActions: React.FC<TableTopBarActionsProps> = ({ list, customTopbarAction, title, label, exportCsv, createActionTitle, handleCreateActionModal, createButtonProps, onSearch, exportButtonProps }): JSX.Element => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const filterAndSearchDirection = isMobile ? 'column' : 'row'

  return (
    <StyledTableHeader isMobile={isMobile}>
      <Box gap={theme.spacing(1)} display={'flex'} alignItems={'center'}>
        <Typography fontWeight={600} fontSize='18px'>{capitalizeFirst(title ?? '')}</Typography>
        {label && <CellBadge color='primary' label={label} />}
        <TableGuidelines />
      </Box>
      <Box display='flex' gap={3} flexDirection={filterAndSearchDirection}>
        {onSearch && <Search onSearch={onSearch} />}
        {exportCsv && <GenericButton
          label='Export'
          buttonSize={ButtonSize.Medium}
          buttonType={ButtonType.Secondary}
          fontWeight={'bold'}
            startIcon={<FileDownloadOutlinedIcon />}
            onClick={exportCsv}
            circularProgressStyles={{ color: grey[300] }}
            {...exportButtonProps}
          />
        }
        {
          createActionTitle?.trim() &&
          <GenericButton
            buttonType={ButtonType.Primary}
            label={createActionTitle}
            buttonSize={ButtonSize.Medium}
            fontWeight={'bold'}
            {...createButtonProps}
            onClick={() => {
              handleCreateActionModal()
            }}
          />
        }
        {customTopbarAction}
      </Box>
    </StyledTableHeader >
  )
}

export default React.memo(TableTopBarActions)
